module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-root"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "label-wall",
    on: {
      "click": _vm.shuffle
    }
  }, [_c('div', {
    staticClass: "center-box"
  }, [_vm._l((_vm.labels), function(label, index) {
    return _c('div', {
      key: label,
      staticClass: "label",
      style: (_vm.getLabelStyle(label, index)),
      on: {
        "click": function($event) {
          _vm.onSelectLabel(label)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(label.name))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "selected-icon"
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-box"
  }, [_c('span', [_vm._v("技术栈")]), _vm._v(" "), _c('p', [_vm._v("已经掌握或者基本掌握的技术名称")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e9f38e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/resume/components/page3.vue
// module id = 189
// module chunks = 0